module.exports = __webpack_public_path__ + "static/media/Jangl@2x.54ae2b1a.png";